import { useMemo, useCallback } from "react";
import { InitialState, FetchFn, FetchCallBackResult, useDataFetch, useTimeRange } from "../../../../core";
import { OpCreationConfig, OpSchema, operationaliseV2ApiService } from "..";
import { OpFragment } from "../../chat";

export const useFetchOpSchemaFromOpConfig = (opConfig: OpCreationConfig, opFragments?: OpFragment[], opId?: string) => {
  const { timeRange } = useTimeRange();
  const { timeZone } = timeRange || {};
  const initialState = useMemo<InitialState<OpSchema, string>>(
    () => ({
      data: null,
      error: null,
      isError: false,
      isFetching: true,
      isSuccess: false
    }),
    []
  );

  const fetchFn = useCallback<FetchFn<OpSchema, string>>(async () => {
    const result: FetchCallBackResult<OpSchema, string> = {
      data: null,
      error: null,
      isError: false,
      isSuccess: false
    };

    try {
      const promise = operationaliseV2ApiService.getOpSchemaFromOpCreationConfig(opConfig, opId, opFragments, timeZone);

      const { data, error, message } = await promise;

      if (error) {
        result.isError = true;
        result.error = message.toString();
      } else {
        result.data = data;
        result.isSuccess = true;
      }
    } catch (err) {
      result.isError = true;
      result.error = err.message?.toString() || err.toString();
    }

    return result;
  }, [opConfig, opFragments, opId, timeZone]);

  return useDataFetch(fetchFn, initialState, true);
};
